var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _line2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabletSectionPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 930,
  viewBox: "0 0 704 930",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 704,
  y1: 0.500488,
  x2: -4.37113e-8,
  y2: 0.500427,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.0005,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.0005,
  width: 704,
  height: 335,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 422,
  width: 460,
  height: 18,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 448,
  width: 460,
  height: 62,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 518,
  width: 460,
  height: 40,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 566,
  width: 460,
  height: 40,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  y: 618,
  width: 460,
  height: 14,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 422,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 496,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 530,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 604,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 704,
  y1: 656.5,
  x2: -4.37113e-8,
  y2: 656.5,
  stroke: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  y: 680,
  width: 152,
  height: 128,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  y: 820,
  width: 152,
  height: 84,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  y: 916,
  width: 152,
  height: 14,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 184,
  y: 680,
  width: 152,
  height: 128,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 184,
  y: 820,
  width: 152,
  height: 84,
  fill: "#E5E5E5"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 184,
  y: 916,
  width: 152,
  height: 14,
  fill: "#E5E5E5"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 368,
  y: 680,
  width: 152,
  height: 128,
  fill: "#E5E5E5"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 368,
  y: 820,
  width: 152,
  height: 84,
  fill: "#E5E5E5"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 368,
  y: 916,
  width: 152,
  height: 14,
  fill: "#E5E5E5"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 552,
  y: 680,
  width: 152,
  height: 128,
  fill: "#E5E5E5"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 552,
  y: 820,
  width: 152,
  height: 84,
  fill: "#E5E5E5"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 552,
  y: 916,
  width: 152,
  height: 14,
  fill: "#E5E5E5"
})));
export default SvgTabletSectionPlaceholder;